import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { InputSelect } from 'components/InputSelect';
import OptionSelect from 'components/OptionSelect';

const SelectFromList = (props) => {
  const {
    id,
    radioOptions,
    dropDownOptions,
    isMultipleSelection,
    inputPlaceholder,
    rootClassName,
    values,
    onChange,
    popupOpenTrigger,
  } = props;

  return (
    <Box className={rootClassName}>
      <InputSelect
        id={id}
        placeholder={inputPlaceholder}
        isMultipleSelection={isMultipleSelection}
        options={dropDownOptions}
        values={values}
        onChange={onChange}
        popupOpenTrigger={popupOpenTrigger}
      />
      {radioOptions?.length > 0 && <br />}
      <OptionSelect
        options={radioOptions}
        values={values}
        onChange={onChange}
        isMultipleSelection={isMultipleSelection}
      />
    </Box>
  );
};

SelectFromList.propTypes = {
  /**
   * Array of options for InputSelect (autocomplete)
   */
  dropDownOptions: PropTypes.array.isRequired,
  /**
   * Array of options for SingleOptionSelect
   */
  radioOptions: PropTypes.array.isRequired,
  /**
   * A flag for enabling several options selection. Works like checkbox.
   */
  isMultipleSelection: PropTypes.bool,
  /**
   * Placeholder of the input.
   */
  inputPlaceholder: PropTypes.string,
  /**
   * Array of selected options. Array of objects in which presents labels and values of these options.
   */
  values: PropTypes.array.isRequired,
  /**
   * Classname for the root div
   */
  rootClassName: PropTypes.string,
  /**
   * Function to call when selected option
   */
  onChange: PropTypes.func.isRequired,

  id: PropTypes.string.isRequired,

  popupOpenTrigger: PropTypes.bool,
};

SelectFromList.defaultProps = {
  inputPlaceholder: '',
  isMultipleSelection: true,
  rootClassName: '',
  popupOpenTrigger: false,
};

export default SelectFromList;
